// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-container {
    position: relative;
    width: 100%;
    padding: 8px;
}

.image-preview-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 10px;
}

.upload-zone {
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.upload-zone:hover, 
.upload-zone.drag-over {
    border-color: #556ee6;
    background-color: #f3f3f9;
} `, "",{"version":3,"sources":["webpack://./src/pages/Virtual Gifts/virtualGifts.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;AAC7B","sourcesContent":[".preview-container {\n    position: relative;\n    width: 100%;\n    padding: 8px;\n}\n\n.image-preview-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    padding: 10px;\n}\n\n.upload-zone {\n    border: 2px dashed #dee2e6;\n    border-radius: 8px;\n    transition: all 0.3s ease;\n}\n\n.upload-zone:hover, \n.upload-zone.drag-over {\n    border-color: #556ee6;\n    background-color: #f3f3f9;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
